export default {
  columns: {
    consignmentNo: '运输委托单号',
    relateFhNo: '关联发货申请单号',
    consignmentStatus: '委托状态',
    feeConfirmStatus: '费用确认状态',
    writeOffStatus: '核销状态',
    transportSegment: '运输段落',
    direction: '正向/逆向',
    originCountry: '发货国',
    originPort: '起运港',
    originWarehouse: '发货仓库',
    destinationCountry: '目的国',
    destinationPort: '目的港',
    destinationWarehouse: '目的仓库',
    businessDepartmentCode: '业务部门编码',
    businessDepartmentName: '业务部门名称',
    customerCode: '客户编码',
    customerName: '客户名称',
    skuProductName: 'SKU/产品名',
    totalCargoValue: '总货值',
    chargeableWeight: '【件重尺】计费重(kg)',
    totalVolume: '【件重尺】总体积(m³)',
    totalWeight: '【件重尺】总重量(kg)',
    segmentTransportMode: '本段运输业务类型',
    containerTypes: '箱型',
    supplierShortName: '供应商简称',
    supplierName: '供应商名称',
    carrierNames: '航司/船司',
    estimatedPayableOriginal: '预估金额（含税）（原币种）',
    totalFreightUsd: '总运费（USD）',
    exceptionStatus: '异常状态',
    exceptionSituation: '异常情况',
    sourceCreator: '来源系统创建人',
    businessCreatedAt: '业务创建时间',
    consignmentCreator: '委托创建人',
    consignmentCreatedAt: '委托创建时间',
    waybillNos: '关联运单号',
    tradeTerms: '贸易条款（清关）',
    expectedArrivalAt: '期望到货时间',
    orderReferenceRemark: '单号备注（PO/FBA/SW）',
    settlementTotalOriginal: '参与结算费用（原币种）'
  },
  feeDimensions: {
    duty: '关税',
    vat: '增值税',
    freight: '运费',
    compensation: '赔偿费',
    preCarriageFreight: '港前运费',
    originCustomsClearance: '港前清关费',
    mainCarriageFreight: '干线运费',
    destinationCustomsClearance: '港后清关费',
    onCarriageFreight: '港后运费',
    other: '其他'
  },
  feeColumns: {
    original: '{name}（原币种）',
    usd: '{name}（USD）'
  },
  title: '报告中心',
  configModules: {
    filter: '报告中心运输委托单共享筛选条件',
    managementTable: '报告中心运输委托单管理视角表格列方案',
    followUpTable: '报告中心运输委托单跟单视角表格列方案'
  },
  transportConsignment: {
    title: '运输委托单报告',
    selectedCount: '已选 {count} 条'
  },
  views: {
    MANAGEMENT: '管理视角',
    FOLLOW_UP: '跟单视角'
  },
  actions: {
    refresh: '刷新',
    export: '导出',
    cancel: '取消'
  },
  filters: {
    title: '报告中心筛选',
    placeholders: {
      input: '请输入查询内容',
      select: '请选择',
      dateRange: '请选择日期范围'
    },
    fields: {
      consignmentNo: '运输委托单号',
      relateFhNo: '关联发货申请单号',
      consignmentStatus: '委托状态',
      feeConfirmStatus: '费用确认状态',
      transportSegment: '运输段落',
      direction: '正向/逆向',
      originWarehouse: '发货仓库',
      originCountry: '发货国',
      destinationWarehouse: '目的仓库',
      destinationCountry: '目的国',
      businessDepartmentName: '业务部门名称',
      customerCode: '客户编码',
      skuProductName: 'SKU/产品名',
      segmentTransportMode: '本段运输业务类型',
      supplierName: '供应商名称',
      exceptionStatus: '异常状态',
      exceptionSituation: '异常情况',
      consignmentCreator: '委托创建人',
      consignmentCreatedAt: '委托创建时间',
      sourceCreator: '来源系统创建人',
      businessCreatedAt: '业务创建时间'
    },
    options: {
      consignmentStatus: {
        0: '未委托',
        1: '已委托',
        2: '已取消'
      },
      feeConfirmStatus: {
        0: '未确认',
        1: '已确认',
        2: '无关'
      },
      writeOffStatus: {
        0: '未核销',
        1: '已核销',
        2: '部分核销'
      },
      transportSegment: {
        1: '港前',
        2: '干线',
        3: '尾程',
        4: '全程',
        5: '港前+干线',
        6: '干线+尾程'
      },
      direction: {
        1: '正向',
        2: '逆向'
      },
      segmentTransportMode: {
        1: '海运整箱',
        2: '海运拼箱',
        3: '空运',
        4: '陆运',
        5: '铁路',
        6: '快递',
        7: '海运滚装轮',
        8: '海运散杂货',
        9: '其他'
      },
      exceptionStatus: {
        0: '无异常',
        1: '有异常'
      }
    }
  },
  export: {
    title: '导出数据',
    description: '导出将使用当前视角、筛选条件、列显隐和列顺序。',
    allRows: '导出全部数据',
    selectedRows: '导出当前所选数据（已选 {count} 条）',
    selectedRowsDisabled: '导出当前所选数据（请先勾选）',
    confirm: '确定导出',
    noSelectedRows: '请先选择需要导出的记录',
    noVisibleColumns: '当前没有可导出的可见列',
    filename: '菜单字段看板_{timestamp}'
  },
  values: {
    view: '报告视角',
    waybill: '运单',
    metricSources: {
      FORWARDER: '货代',
      WAREHOUSE: '仓库',
      THEORETICAL: '理论',
      MIXED: '混合'
    },
    missingUsdRate: '缺少 USD 汇率：{currencies}',
    actual: '实际',
    notApplicable: '不适用'
  },
  messages: {
    permissionDenied: '没有当前报告视角的访问权限',
    loadListFailed: '加载报告列表失败',
    exportSuccess: '导出任务已完成',
    exportFailed: '导出失败，请稍后重试'
  }
}
